import styled, { css } from 'styled-components';
import { ToolbarPositions } from '../draggableToolbar/DraggableToolbar.types';
import { useToolbarPosition } from '@/hooks/useToolbarPosition';

const TooltipStyled = styled.div`
  ${() => {
    const pos = useToolbarPosition();
    return css`
      position: absolute;
      right: 3.25em;
      top: 50%;
      transform: translateY(-50%);
      white-space: nowrap;
      height: fit-content;
      width: fit-content;
      display: none;

      font-weight: 400;
      font-size: 0.875em;
      line-height: 1.5em;
      color: var(--color-white);
      text-align: center;

      ${(pos === ToolbarPositions.TopLeft ||
        pos === ToolbarPositions.CenterLeft ||
        pos === ToolbarPositions.BottomLeft) &&
      css`
        left: 3.25em;
      `}
      &.hidden {
        display: none;
      }

      .tooltip-bg {
        position: absolute;
        top: 0;
        z-index: -1;
        border-radius: 0.188em;
        background: var(--color-midnight-darker);
        filter: opacity(0.75);
        width: 100%;
        height: 100%;
      }
      .tooltip-text {
        padding: 0.25em 0.75em;
      }
    `;
  }}
`;

export default TooltipStyled;
